<template>
  <div>
    <div class="menu-title">
      用户管理
    </div>
    <div class="menu-content">
      <div>
        <el-form :inline="true" :model="qo" size="small" class="demo-form-inline">
          <el-form-item label="名称：">
            <el-input v-model="qo.LIKES_name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="qo.EQS_type" placeholder="请选择类型">
              <el-option value="" label="全部"></el-option>
              <el-option value="admin" label="管理员"></el-option>
              <el-option value="user" label="普通用户"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-list">
        <el-table :data="result.records" style="width: 100%">
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <el-table-column prop="realAvatarUrl" label="头像">
            <template v-slot="scope" >
              <el-image v-if="scope.row.realAvatarUrl != null && scope.row.realAvatarUrl.length > 0"
                        style="width: 70px; height: 70px;border-radius: 50%;background-color: #b0b4b9;"
                        :src="scope.row.realAvatarUrl"
                        :preview-src-list="[scope.row.realAvatarUrl]"
                        fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="昵称"></el-table-column>
          <el-table-column label="newApi用户名" min-width="170" show-overflow-tooltip>
            <template v-slot="scope">{{ scope.row.newApiUsername || '-' }}</template>
          </el-table-column>
          <el-table-column prop="phoneNum" label="手机号"></el-table-column>
          <el-table-column prop="realAvatarUrl" label="类型">
            <template v-slot="scope" >
              {{scope.row.type == 'admin'?'管理员':scope.row.type == 'user'?'普通用户':''}}
            </template>
          </el-table-column>
          <el-table-column prop="level" label="会员">
            <template v-slot="scope" >
              {{scope.row.level == 0?'免费会员':scope.row.type == 1?'一级会员':'二级会员'}}
            </template>
          </el-table-column>
          <el-table-column prop="onlineStatus" label="在线状态">
            <template v-slot="scope">
              {{scope.row.onlineStatus ? '在线' : '离线'}}
            </template>
          </el-table-column>
          <el-table-column label="最后登录日期" width="130">
            <template v-slot="scope">{{ formatStatisticsDate(scope.row.lastLoginTime) }}</template>
          </el-table-column>
          <el-table-column prop="postCount" label="记忆圈帖子数" width="110"></el-table-column>
          <el-table-column prop="totalTokens" label="记忆圈消耗 Token" width="140"></el-table-column>
          <el-table-column prop="likeCount" label="点赞数" width="80"></el-table-column>
          <el-table-column prop="commentCount" label="评论数" width="80"></el-table-column>
          <el-table-column label="操作" width="170">
            <template v-slot="scope">
              <el-button @click.native.prevent="modifyRow(scope.row)" type="text" size="small">
                查看
              </el-button>
              <el-button v-if="scope.row.type === 'user'"
                         icon="el-icon-data-analysis"
                         @click.native.prevent="openDataDialog(scope.row)"
                         type="text"
                         size="small">
                数据
              </el-button>
              <el-button @click.native.prevent="removeRow(scope.row)" type="text" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-box">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page="qo.pageNo"
                       :page-size="qo.pageSize"
                       layout="total, prev, pager, next"
                       :total="result.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="查看"
        :visible.sync="cmdDialogVisible"
        width="min(90vw, 640px)">
      <el-form ref="cmd" v-loading="cmdLoading" label-width="120px" :model="cmd" class="user-view-form">
        <el-form-item label="头像" prop="realAvatarUrl">
          <el-image
              v-if="cmd.realAvatarUrl"
              style="width: 70px; height: 70px;border-radius: 50%;background-color: #b0b4b9;"
              :src="cmd.realAvatarUrl"
              :preview-src-list="[cmd.realAvatarUrl]"
              fit="contain"></el-image>
        </el-form-item>
        <el-form-item label="昵称" prop="realName">
          <el-input v-model="cmd.realName" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="newApi用户名" prop="newApiUsername">
          <el-input :value="cmd.newApiUsername || '-'" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNum">
          <el-input v-model="cmd.phoneNum" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="cmd.type" disabled style="width: 100%">
            <el-option value="admin" label="管理员"></el-option>
            <el-option value="user" label="普通用户"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员" prop="level">
          <el-select v-model="cmd.level" disabled style="width: 100%">
            <el-option :value="0" label="免费会员"></el-option>
            <el-option :value="1" label="一级会员"></el-option>
            <el-option :value="1" label="二级会员"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订阅总额度" prop="subscriptionTotalQuota">
          <el-input :value="formatQuotaValue(cmd.subscriptionTotalQuota)" disabled></el-input>
        </el-form-item>
        <el-form-item label="订阅剩余额度" prop="subscriptionRemainingQuota">
          <el-input :value="formatQuotaValue(cmd.subscriptionRemainingQuota)" disabled></el-input>
        </el-form-item>
        <el-form-item label="订阅使用率" prop="subscriptionUsagePercent">
          <el-input :value="formatQuotaValue(cmd.subscriptionUsagePercent, '%')" disabled></el-input>
        </el-form-item>
        <el-form-item label="上次重置时间" prop="lastResetTime">
          <el-input :value="cmd.lastResetTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="下次重置时间" prop="nextResetTime">
          <el-input :value="cmd.nextResetTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="最后登录日期" prop="lastLoginTime">
          <el-input :value="formatStatisticsDate(cmd.lastLoginTime)" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="level">
          <el-select v-model="cmd.onlineStatus" disabled style="width: 100%">
            <el-option :value="true" label="在线"></el-option>
            <el-option :value="false" label="离线"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记忆圈帖子数" prop="postCount">
          <el-input v-model="cmd.postCount" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="记忆圈消耗 Token" prop="totalTokens">
          <el-input v-model="cmd.totalTokens" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="点赞数" prop="likeCount">
          <el-input v-model="cmd.likeCount" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="评论数" prop="commentCount">
          <el-input v-model="cmd.commentCount" placeholder="" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cmdDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :title="`用户数据 - ${dataUser.realName || '-'}`"
        :visible.sync="dataDialogVisible"
        width="92%"
        top="3vh"
        class="user-data-dialog"
        :close-on-click-modal="false"
        @opened="initDataCharts"
        @closed="disposeDataCharts">
      <div v-loading="dataLoading" class="user-data-content">
        <el-form :inline="true" size="small" class="data-query-form">
          <el-form-item label="统计时间：">
            <el-date-picker
                v-model="dataQuery.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="queryMemoryData(true)">查询</el-button>
          </el-form-item>
        </el-form>

        <section class="data-section">
          <h3>用户发帖记录（总价格：{{ formatTokenPrice(memoryStatistics.userPostTotalTokens) }}）</h3>
          <el-table :data="postResult.records" height="280" border>
            <el-table-column label="序号" width="80" align="center">
              <template v-slot="scope">
                {{ (dataQuery.pageNo - 1) * dataQuery.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="发布日期" min-width="140">
              <template v-slot="scope">{{ formatStatisticsDate(scope.row.sendTime) }}</template>
            </el-table-column>
            <el-table-column prop="totalTokens" label="Token 使用量" min-width="140"></el-table-column>
            <el-table-column label="价格" min-width="140">
              <template v-slot="scope">
                {{ formatTokenPrice(scope.row.totalTokens) }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="120">
              <template v-slot="scope">
                <el-tag :type="postStatusType(scope.row.status)" size="small">
                  {{ postStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              background
              class="data-pagination"
              layout="total, prev, pager, next"
              :current-page="dataQuery.pageNo"
              :page-size="dataQuery.pageSize"
              :total="postResult.total"
              @current-change="handleDataPageChange">
          </el-pagination>
        </section>

        <div class="data-chart-grid">
          <section class="data-section chart-section">
            <h3>NPC 发帖（总价格：{{ formatTokenPrice(memoryStatistics.npcPostTotalTokens) }}）</h3>
            <div ref="npcPostChart" class="data-chart"></div>
          </section>
          <section class="data-section chart-section">
            <h3>NPC 评论（总价格：{{ formatTokenPrice(memoryStatistics.npcCommentTotalTokens) }}）</h3>
            <div ref="npcCommentChart" class="data-chart"></div>
          </section>
        </div>

        <section v-if="hasNewApiUsername()" class="data-section chart-section">
          <div class="conversation-chart-header">
            <h3>对话使用量（总计：{{ formatConversationTotal() }}）</h3>
            <div class="conversation-total-calculator">
              <el-input
                  v-model.trim="conversationTotalInput"
                  type="number"
                  min="0"
                  step="0.01"
                  clearable
                  placeholder="请输入总额"
                  class="conversation-total-input"
                  @keyup.enter.native="calculateConversationPercentage">
                <template slot="prepend">元</template>
              </el-input>
              <el-button
                  type="primary"
                  icon="el-icon-data-analysis"
                  @click="calculateConversationPercentage">
                计算
              </el-button>
            </div>
          </div>
          <div ref="conversationTokenChart" class="data-chart"></div>
        </section>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dataDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';
import axios from 'axios';

var _this;
const emptyMemoryStatistics = () => ({
  dates: [],
  npcPostCounts: [],
  npcPostTokens: [],
  npcCommentCounts: [],
  npcCommentTokens: [],
  userPostTotalTokens: 0,
  npcPostTotalTokens: 0,
  npcCommentTotalTokens: 0
});
const emptyConversationStatistics = () => ({
  dates: [],
  chatMemoryCosts: [],
  importMemoryCosts: [],
  dailyConversationCosts: [],
  conversationTotalCost: 0
});
export default {
  name: 'user',
  props: ['activeMenuName'],
  data() {
    return {
      fileUrl: getFileUrl(),
      qo: {
        pageNo: 1,
        pageSize: 10,
        LIKES_name: ''
      },
      result: {
        records: [],
        total: 0
      },
      dialogName: '编辑',
      cmdDialogVisible: false,
      cmdLoading: false,
      cmdRequestUserId: null,
      deputyDialogVisible: false,
      cmd: {},
      dataDialogVisible: false,
      dataLoading: false,
      dataUser: {},
      dataQuery: {
        dateRange: [],
        pageNo: 1,
        pageSize: 10
      },
      postResult: {
        records: [],
        total: 0
      },
      memoryStatistics: emptyMemoryStatistics(),
      conversationStatistics: emptyConversationStatistics(),
      conversationTotalInput: '',
      appliedConversationTotal: null,
      dataCharts: {
        npcPost: null,
        npcComment: null,
        conversationToken: null
      },
      rules: {

      }
    }
  },
  mounted() {
    _this = this;
    _this.queryData();
    if (window.addEventListener) {
      window.addEventListener('resize', _this.resizeDataCharts);
    }
  },
  beforeDestroy() {
    if (window.removeEventListener) {
      window.removeEventListener('resize', _this.resizeDataCharts);
    }
    _this.disposeDataCharts();
  },
  methods: {
    queryData() {
      request({
        url: `/user/query_pages`,
        method: 'post',
        data: _this.qo
      }).then(res => {
        res.records.forEach(row => {
          row.realAvatarUrl = _this.fileUrl + row.realAvatarUrl;
        });
        _this.result.records = res.records;
        _this.result.total = res.total;

        const deviceIds = res.records
          .map(row => row.deviceCode)
          .filter(code => code);

        if (deviceIds.length > 0) {
          _this.fetchOnlineStatus(deviceIds);
        }
      });
    },
    handleCurrentChange(val) {
      _this.qo.pageNo = val;
      _this.queryData();
    },
    openDataDialog(item) {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 6);
      _this.dataUser = item;
      _this.dataQuery.dateRange = [_this.formatDate(startDate), _this.formatDate(endDate)];
      _this.dataQuery.pageNo = 1;
      _this.postResult = {records: [], total: 0};
      _this.memoryStatistics = emptyMemoryStatistics();
      _this.conversationStatistics = emptyConversationStatistics();
      _this.conversationTotalInput = '';
      _this.appliedConversationTotal = null;
      _this.dataDialogVisible = true;
      _this.$nextTick(() => _this.queryMemoryData(true));
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatStatisticsDate(value) {
      const text = String(value || '');
      const compact = /^(\d{4})(\d{2})(\d{2})$/.exec(text);
      if (compact) {
        return `${compact[1]}-${compact[2]}-${compact[3]}`;
      }
      const date = /^(\d{4}-\d{2}-\d{2})(?:[ T].*)?$/.exec(text);
      return date ? date[1] : '-';
    },
    memoryDataParams() {
      return {
        userId: _this.dataUser.id,
        startDate: _this.dataQuery.dateRange[0],
        endDate: _this.dataQuery.dateRange[1],
        pageNo: _this.dataQuery.pageNo,
        pageSize: _this.dataQuery.pageSize
      };
    },
    hasNewApiUsername() {
      return Boolean(String(_this.dataUser.newApiUsername || '').trim());
    },
    queryMemoryData(resetPage) {
      if (!_this.dataQuery.dateRange || _this.dataQuery.dateRange.length !== 2) {
        _this.$message.warning('请选择统计时间');
        return;
      }
      if (resetPage) {
        _this.dataQuery.pageNo = 1;
      }
      _this.dataLoading = true;
      const requests = [_this.fetchMemoryPosts(), _this.fetchMemoryStatistics()];
      if (_this.hasNewApiUsername()) {
        requests.push(_this.fetchConversationUsage());
      }
      return Promise.all(requests)
        .catch(() => {})
        .finally(() => {
          _this.dataLoading = false;
        });
    },
    fetchMemoryPosts() {
      return request({
        url: '/user/memory-circle-data/posts',
        method: 'post',
        data: _this.memoryDataParams()
      }).then(res => {
        _this.postResult.records = res.records || [];
        _this.postResult.total = res.total || 0;
      });
    },
    fetchMemoryStatistics() {
      return request({
        url: '/user/memory-circle-data/statistics',
        method: 'post',
        data: _this.memoryDataParams()
      }).then(res => {
        _this.memoryStatistics = {
          dates: (res.dates || []).map(_this.formatStatisticsDate),
          npcPostCounts: res.npcPostCounts || [],
          npcPostTokens: res.npcPostTokens || [],
          npcCommentCounts: res.npcCommentCounts || [],
          npcCommentTokens: res.npcCommentTokens || [],
          userPostTotalTokens: res.userPostTotalTokens || 0,
          npcPostTotalTokens: res.npcPostTotalTokens || 0,
          npcCommentTotalTokens: res.npcCommentTotalTokens || 0
        };
        _this.renderDataCharts();
      });
    },
    fetchConversationUsage() {
      return request({
        url: '/user/memory-circle-data/conversation-usage',
        method: 'post',
        data: _this.memoryDataParams()
      }).then(res => {
        const chatMemoryQuotas = res.chatMemoryQuotas || [];
        const importMemoryQuotas = res.importMemoryQuotas || [];
        _this.conversationStatistics = {
          dates: (res.dates || []).map(_this.formatStatisticsDate),
          chatMemoryCosts: chatMemoryQuotas.map(_this.quotaToPrice),
          importMemoryCosts: importMemoryQuotas.map(_this.quotaToPrice),
          dailyConversationCosts: chatMemoryQuotas.map((quota, index) =>
            _this.quotaToPrice(Number(quota || 0) + Number(importMemoryQuotas[index] || 0))),
          conversationTotalCost: _this.quotaToPrice(res.conversationTotalQuota)
        };
        _this.renderDataCharts();
      });
    },
    handleDataPageChange(pageNo) {
      _this.dataQuery.pageNo = pageNo;
      _this.dataLoading = true;
      _this.fetchMemoryPosts()
        .catch(() => {})
        .finally(() => {
          _this.dataLoading = false;
        });
    },
    initDataCharts() {
      if (!_this.dataCharts.npcPost && _this.$refs.npcPostChart) {
        _this.dataCharts.npcPost = _this.$echarts.init(_this.$refs.npcPostChart);
        _this.dataCharts.npcComment = _this.$echarts.init(_this.$refs.npcCommentChart);
      }
      if (_this.hasNewApiUsername() && !_this.dataCharts.conversationToken && _this.$refs.conversationTokenChart) {
        _this.dataCharts.conversationToken = _this.$echarts.init(_this.$refs.conversationTokenChart);
      }
      _this.renderDataCharts();
    },
    barChartOption(countName, counts, tokens) {
      const priceName = '价格';
      const priceData = tokens.map(token => ({
        value: _this.quotaToPrice(token),
        tokens: Number(token || 0)
      }));
      return {
        color: ['#409EFF', '#67C23A'],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {type: 'shadow'},
          formatter(params) {
            if (!params || params.length === 0) {
              return '';
            }
            const countItem = params.find(item => item.seriesName === countName);
            const priceItem = params.find(item => item.seriesName === priceName);
            const priceItemData = priceItem && priceItem.data ? priceItem.data : {};
            return [
              params[0].axisValue,
              countItem ? `${countItem.marker}${countName}：${countItem.value}` : '',
              priceItem ? `${priceItem.marker}Token 使用量：${_this.formatToken(priceItemData.tokens)}` : '',
              priceItem ? `${priceItem.marker}价格：${_this.formatPrice(priceItem.value)}` : ''
            ].filter(item => item).join('<br/>');
          }
        },
        legend: {data: [countName, priceName]},
        grid: {left: 16, right: 16, top: 46, bottom: 48, containLabel: true},
        xAxis: {
          type: 'category',
          data: _this.memoryStatistics.dates,
          axisLabel: {rotate: _this.memoryStatistics.dates.length > 10 ? 35 : 0}
        },
        yAxis: [
          {type: 'value', name: '数量', minInterval: 1},
          {
            type: 'value',
            name: '元',
            axisLabel: {
              formatter(value) {
                return Number(value).toFixed(6);
              }
            }
          }
        ],
        series: [
          {name: countName, type: 'bar', data: counts, yAxisIndex: 0, barMaxWidth: 32},
          {name: priceName, type: 'bar', data: priceData, yAxisIndex: 1, barMaxWidth: 32}
        ]
      };
    },
    calculateConversationPercentage() {
      const input = String(_this.conversationTotalInput === null ? '' : _this.conversationTotalInput).trim();
      if (!input) {
        _this.appliedConversationTotal = null;
        _this.renderDataCharts();
        return;
      }
      const total = Number(input);
      if (!Number.isFinite(total) || total <= 0) {
        _this.$message.warning('总额必须大于 0');
        return;
      }
      _this.appliedConversationTotal = total;
      _this.renderDataCharts();
    },
    isConversationPercentageMode() {
      return Number.isFinite(_this.appliedConversationTotal) && _this.appliedConversationTotal > 0;
    },
    conversationDisplayValues(costs) {
      if (!_this.isConversationPercentageMode()) {
        return costs;
      }
      return costs.map(cost => Number(((Number(cost || 0) / _this.appliedConversationTotal) * 100).toFixed(6)));
    },
    formatPercentage(value) {
      const percentage = Number(value || 0);
      return `${(Number.isFinite(percentage) ? percentage : 0).toFixed(6)}%`;
    },
    formatConversationValue(value) {
      return _this.isConversationPercentageMode()
        ? _this.formatPercentage(value)
        : _this.formatPrice(value);
    },
    formatConversationTotal() {
      if (!_this.isConversationPercentageMode()) {
        return _this.formatPrice(_this.conversationStatistics.conversationTotalCost);
      }
      return _this.formatPercentage(
        (_this.conversationStatistics.conversationTotalCost / _this.appliedConversationTotal) * 100
      );
    },
    renderDataCharts() {
      if (_this.dataCharts.npcPost) {
        _this.dataCharts.npcPost.setOption(_this.barChartOption(
          '发帖数',
          _this.memoryStatistics.npcPostCounts,
          _this.memoryStatistics.npcPostTokens
        ), true);
      }
      if (_this.dataCharts.npcComment) {
        const commentOption = _this.barChartOption(
          '评论数',
          _this.memoryStatistics.npcCommentCounts,
          _this.memoryStatistics.npcCommentTokens
        );
        commentOption.color = ['#E6A23C', '#F56C6C'];
        _this.dataCharts.npcComment.setOption(commentOption, true);
      }
      if (!_this.dataCharts.conversationToken) {
        return;
      }
      const chatMemoryData = _this.conversationDisplayValues(_this.conversationStatistics.chatMemoryCosts);
      const importMemoryData = _this.conversationDisplayValues(_this.conversationStatistics.importMemoryCosts);
      const dailyConversationData = _this.conversationDisplayValues(_this.conversationStatistics.dailyConversationCosts);
      _this.dataCharts.conversationToken.setOption({
        color: ['#409EFF', '#E6A23C', '#67C23A'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {type: 'shadow'},
          formatter(params) {
            return [params[0].axisValue]
              .concat(params.map(item => `${item.marker}${item.seriesName}：${_this.formatConversationValue(item.value)}`))
              .join('<br/>');
          }
        },
        legend: {data: ['聊天记忆', '导入记忆', '每天总使用量']},
        grid: {left: 16, right: 16, top: 46, bottom: 48, containLabel: true},
        xAxis: {
          type: 'category',
          data: _this.conversationStatistics.dates,
          axisLabel: {rotate: _this.conversationStatistics.dates.length > 10 ? 35 : 0}
        },
        yAxis: {type: 'value', name: _this.isConversationPercentageMode() ? '%' : '元'},
        series: [
          {
            name: '聊天记忆',
            type: 'bar',
            stack: 'conversationToken',
            data: chatMemoryData,
            barMaxWidth: 40
          },
          {
            name: '导入记忆',
            type: 'bar',
            stack: 'conversationToken',
            data: importMemoryData,
            barMaxWidth: 40
          },
          {
            name: '每天总使用量',
            type: 'line',
            data: dailyConversationData,
            symbolSize: 7,
            z: 3
          }
        ]
      }, true);
    },
    resizeDataCharts() {
      Object.keys(_this.dataCharts).forEach(key => {
        if (_this.dataCharts[key]) {
          _this.dataCharts[key].resize();
        }
      });
    },
    disposeDataCharts() {
      Object.keys(_this.dataCharts).forEach(key => {
        if (_this.dataCharts[key]) {
          _this.dataCharts[key].dispose();
          _this.dataCharts[key] = null;
        }
      });
    },
    postStatusText(status) {
      const textMap = {
        draft: '草稿',
        published: '已发布',
        hidden: '已隐藏',
        deleted: '已删除'
      };
      return textMap[status] || status || '-';
    },
    postStatusType(status) {
      const typeMap = {
        draft: 'info',
        published: 'success',
        hidden: 'warning',
        deleted: 'danger'
      };
      return typeMap[status] || 'info';
    },
    formatQuotaValue(value, suffix = '') {
      return value === null || value === undefined || value === '' ? '-' : `${value}${suffix}`;
    },
    quotaToPrice(value) {
      const quota = Number(value || 0);
      const exchangeRate = Number(window.g && window.g.usdCnyRate);
      return Number.isFinite(quota) && Number.isFinite(exchangeRate) && exchangeRate > 0
        ? quota / 500000 * exchangeRate : NaN;
    },
    formatToken(value) {
      const token = Number(value || 0);
      return (Number.isFinite(token) ? token : 0).toLocaleString('en-US');
    },
    formatTokenPrice(value) {
      return _this.formatPrice(_this.quotaToPrice(value));
    },
    formatPrice(value) {
      const price = Number(value);
      return Number.isFinite(price) ? `${price.toFixed(6)} 元` : '汇率未配置';
    },
    fetchOnlineStatus(deviceIds) {
      return axios.post(`${window.g.agentBaseURL}/gateway-client-binding/query_gateway_client_binding_list`, {
        clientCodes: deviceIds
      }).then(res => {
        if (res.data && res.data.code === 'SUCCESS' && Array.isArray(res.data.data)) {
          const onlineClientCodes = new Set(res.data.data
            .map(item => item && item.clientCode)
            .filter(clientCode => clientCode));
          _this.result.records.forEach(row => {
            _this.$set(row, 'onlineStatus', onlineClientCodes.has(row.deviceCode));
          });
        }
      }).catch(err => {
        console.error('获取设备在线状态失败:', err);
      });
    },
    removeRow(item) {
      _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: `/user/remove/${item.id}`,
          method: 'post'
        }).then(res => {
          _this.$message.success("删除成功");
          _this.queryData();
        });
      }).catch(() => {
      });
    },
    createRow() {
      _this.dialogName = '添加';
      _this.cmdDialogVisible = true;
      _this.$nextTick(() => {
        _this.cmd = {
          name: "",
        };
        _this.$refs.cmd.resetFields();
      });
    },
    modifyRow(item) {
      _this.dialogName = '编辑';
      const userId = item.id;
      _this.cmd = Object.assign(JSON.parse(JSON.stringify(item)), {
        subscriptionTotalQuota: null,
        subscriptionRemainingQuota: null,
        subscriptionUsagePercent: null,
        lastResetTime: '--',
        nextResetTime: '--'
      });
      _this.cmdRequestUserId = userId;
      _this.cmdLoading = true;
      _this.cmdDialogVisible = true;
      return request({
        url: '/user/getnewapiquota',
        method: 'post',
        data: {userId}
      }).then(res => {
        if (_this.cmdRequestUserId !== userId) {
          return;
        }
        _this.$set(_this.cmd, 'subscriptionTotalQuota', res.subscriptionTotalQuota);
        _this.$set(_this.cmd, 'subscriptionRemainingQuota', res.subscriptionRemainingQuota);
        _this.$set(_this.cmd, 'subscriptionUsagePercent', res.subscriptionUsagePercent);
        _this.$set(_this.cmd, 'lastResetTime', res.lastResetTime);
        _this.$set(_this.cmd, 'nextResetTime', res.nextResetTime);
      }).finally(() => {
        if (_this.cmdRequestUserId === userId) {
          _this.cmdLoading = false;
        }
      });
    },
    submitModify() {
      this.$refs.cmd.validate((valid) => {
        if (valid) {
          if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
            request({
              url: `/user/modify`,
              method: 'post',
              data: _this.cmd
            }).then(res => {
              _this.$message.success("编辑成功");
              _this.cmdDialogVisible = false;
              _this.queryData();
            });
          } else {
            request({
              url: `/user/create`,
              method: 'post',
              data: _this.cmd
            }).then(res => {
              _this.$message.success("添加成功");
              _this.cmdDialogVisible = false;
              _this.queryData();
            });
          }
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.user-view-form {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.user-data-content {
  max-height: 78vh;
  overflow-y: auto;
  padding: 0 4px 8px;
}

.data-query-form {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 12px 0 4px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.data-section {
  padding: 18px 0;
  border-bottom: 1px solid #ebeef5;

  h3 {
    margin: 0 0 14px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
  }
}

.data-pagination {
  margin-top: 14px;
  text-align: right;
}

.data-chart-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 24px;
}

.conversation-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;

  h3 {
    margin: 0;
  }
}

.conversation-total-calculator {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}

.conversation-total-input {
  width: 220px;
}

.data-chart {
  width: 100%;
  height: 300px;
}

@media (max-width: 1100px) {
  .data-chart-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .conversation-chart-header {
    align-items: flex-start;
    flex-direction: column;
  }
}

</style>
